module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      'sidebar-open': _vm.isSideBarOpen
    }
  }, [_c('img', {
    staticClass: "logo hide-md",
    attrs: {
      "src": require("../assets/ipl-logo.png"),
      "alt": "ipl logo"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn back-btn show-md",
    on: {
      "click": _vm.closeSideBar
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/'
      },
      "exact": ""
    }
  }, [_vm._v("\n    Home\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/finals'
      }
    }
  }, [_vm._v("\n    Season Finals\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Teams")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/team-wins'
      }
    }
  }, [_vm._v("\n      by Wins\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/team-boundries'
      }
    }
  }, [_vm._v("\n      by Boundries\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Batsmen")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-total-runs'
      }
    }
  }, [_vm._v("\n      by Runs\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-individual-scores'
      }
    }
  }, [_vm._v("\n      by Scores\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-boundries'
      }
    }
  }, [_vm._v("\n      by Boundries\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Bowlers")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/bowler-total-wickets'
      }
    }
  }, [_vm._v("\n      by Wickets\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/bowler-economy'
      }
    }
  }, [_vm._v("\n      by Economy\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Player Awards")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-motm'
      }
    }
  }, [_vm._v("\n      Man of Match\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-orange-caps'
      }
    }
  }, [_vm._v("\n      Orange Caps\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-purple-caps'
      }
    }
  }, [_vm._v("\n      Purple Caps\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129e4130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 392
// module chunks = 1